type VehiclePricing = {
  startPriceTTCTFC: number | null
  startPriceTTCHF: number | null
  startPriceHTTFC: number | null
  startPriceHTHF: number | null
  reserveTTCTFC: number | null
  reserveTTCHF: number | null
  reserveHTTFC: number | null
  reserveHTHF: number | null
  reservePriceSeller: number | null
  achatImmediatTTCTFC: number | null
  achatImmediatTTCHF: number | null
  achatImmediatHTTFC: number | null
  achatImmediatHTHF: number | null
  estimationVPAutoTTCTFC: number | null
  estimationVPAutoTTCHF: number | null
  estimationVPAutoHTTFC: number | null
  coteArgusPriceDate: number | null
  coteArgusKm: number | null
  coteMarche: number | null
  prixNeufHT: number | null
  prixNeufTTC: number | null
  estimationApporteur: number | null
  bidPriceIncrement: number | null
  tarifAcheteurCode: number | null
  tarifAcheteur: number | null
  withdrawalPrice: number | null
  adjudicatedPriceHTHF: number | null
  adjudicatedPriceTTCHF: number | null
  adjudicatedPriceHTTFC: number | null
  adjudicatedPriceTTCTFC: number | null
  invoicePrice: number | null
  estimationSeller: number | null
  sellerPriceMinHTHF: number | null
  sellerPriceMinTTCHF: number | null
  sellerPriceMinHTTFC: number | null
  sellerPriceMinTTCTFC: number | null
  pricingWeb: number | null
  retailTransactionPrice: number | null
  averageSellingTime: number | null
  averageSellingTimeInternal: number | null
  reconditioningCostsSeller: number | null
  reconditioningCostsInspection: number | null
  reconditioningCostsInternal: number | null
  reconditioningCostsFinal: number | null
  priceAutobiz: number | null
  tvaRecuperable: boolean
}

const defaultVehiclePricing: VehiclePricing = {
  startPriceTTCTFC: 0,
  startPriceTTCHF: 0,
  startPriceHTTFC: 0,
  startPriceHTHF: 0,
  reserveTTCTFC: 0,
  reserveTTCHF: 0,
  reserveHTTFC: 0,
  reserveHTHF: 0,
  reservePriceSeller: 0,
  achatImmediatTTCTFC: 0,
  achatImmediatTTCHF: 0,
  achatImmediatHTTFC: 0,
  achatImmediatHTHF: 0,
  estimationVPAutoTTCTFC: 0,
  estimationVPAutoTTCHF: 0,
  estimationVPAutoHTTFC: 0,
  coteArgusPriceDate: 0,
  coteArgusKm: 0,
  coteMarche: 0,
  prixNeufHT: 0,
  prixNeufTTC: 0,
  estimationApporteur: null,
  bidPriceIncrement: 0,
  tarifAcheteurCode: 0,
  tarifAcheteur: 0,
  withdrawalPrice: 0,
  adjudicatedPriceHTHF: 0,
  adjudicatedPriceTTCHF: 0,
  adjudicatedPriceHTTFC: 0,
  adjudicatedPriceTTCTFC: 0,
  invoicePrice: 0,
  estimationSeller: 0,
  sellerPriceMinHTHF: 0,
  sellerPriceMinTTCHF: 0,
  sellerPriceMinHTTFC: 0,
  sellerPriceMinTTCTFC: 0,
  pricingWeb: 0,
  retailTransactionPrice: 0,
  averageSellingTime: 0,
  averageSellingTimeInternal: 0,
  reconditioningCostsSeller: 0,
  reconditioningCostsInspection: 0,
  reconditioningCostsInternal: 0,
  reconditioningCostsFinal: 0,
  priceAutobiz: 0,
  tvaRecuperable: true,
}

export type { VehiclePricing }
export { defaultVehiclePricing }
